import React from 'react';
import { isCapabilityEnabled } from 'owa-capabilities';
import { headerFullBleedCapability } from 'owa-capabilities-definitions/lib/headerFullBleedCapability';
import classNames from 'owa-classnames';
import { observer } from 'owa-mobx-react';
import { useComputedValue } from 'owa-react-hooks/lib/useComputed';
import { getCurrentThemeId, getHeaderImageData } from 'owa-theme';
import { headerMain, headerFullBleed } from './OwaHeader.scss';

interface OwaHeaderBackgroundProps {
    children: React.ReactNode;
    onMouseEnter?: (e: React.MouseEvent<HTMLDivElement>) => void;
    onMouseLeave?: (e: React.MouseEvent<HTMLDivElement>) => void;
    onFocus?: (e: React.FocusEvent<HTMLDivElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLDivElement>) => void;
}

const defaultExport: React.MemoExoticComponent<
    React.ForwardRefExoticComponent<
        Omit<OwaHeaderBackgroundProps & React.RefAttributes<HTMLDivElement>, 'ref'> &
            React.RefAttributes<HTMLDivElement>
    >
> = observer(
    React.forwardRef<HTMLDivElement, OwaHeaderBackgroundProps>(function OwaHeaderBackground(
        props: OwaHeaderBackgroundProps,
        ref: React.Ref<HTMLDivElement>
    ) {
        const { children, onMouseEnter, onMouseLeave, onFocus, onBlur } = props;
        const themeId = getCurrentThemeId();
        const headerImageStyles = useComputedValue(() => {
            const headerImageData = getHeaderImageData(themeId);
            return {
                backgroundImage: headerImageData.BackgroundImageUrl
                    ? `url(${headerImageData.BackgroundImageUrl})`
                    : 'none',
            };
        }, [themeId]);

        return (
            <div
                ref={ref}
                style={headerImageStyles}
                className={classNames(
                    headerMain,
                    isCapabilityEnabled(headerFullBleedCapability) && headerFullBleed
                )}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onFocus={onFocus}
                onBlur={onBlur}
            >
                {children}
            </div>
        );
    }),
    'OwaHeaderBackground'
);

export default defaultExport;
